module.exports = __webpack_public_path__ + "2968dfb5e31995709f98d758c2f8383d.pdf";